import React from "react";
import Link from "shared/components/Link";

import Str from "shared/components/Str";

import { URLS } from "apps/signup/util/constants";

import Logo from "./Logo";

const Header = () => {
	return (
		<div className="splashdtf-header">
			<Logo />

			<div className="splashdtf-header-signin">
				<Str className="splashdtf-header-signin-text">
					Have an account?
				</Str>
				<Link
					className="splashdtf-header-signin-splashButton"
					to={URLS.LOGIN}
				>
					<Str>Sign in</Str>
				</Link>
			</div>
		</div>
	);
};

export default Header;



// WEBPACK FOOTER //
// ./src/apps/splash_desktop/components/Header.jsx